import { ol_Feature } from "@omnia/exports/openlayers"
import { FieldViewModel, DatalayersMap, fields } from "../omnia"
import { IDatalayerMapDependencies } from "../types"

export class SatelliteMap {

    readonly map: DatalayersMap

    private featureSelectionFilter: (feature: ol_Feature) => boolean = f => false

    private watcher: Function

    constructor(dependencies: IDatalayerMapDependencies) {

        const map = this.map = new DatalayersMap(dependencies, {
            selecInteractionFactory: m => new omnia.map.MapSelectInteraction2(m.getMap(), f => this.featureSelectionFilter(f))
        })

        map.enableMultipleSelection = true
        map.fieldsLayer.fillColorProvider = f => "transparent"
    }

    dispose() {
        this.watcher && this.watcher()
        this.watcher = undefined
    }

    disableSelection() {
        this.featureSelectionFilter = f => false
        this.map.setSelectableLayers([])
        this.map.clearSelection()
    }

    enableSelection(cropping: boolean, filter: (field: FieldViewModel) => boolean, watcher: (fields: FieldViewModel[]) => void) {

        this.dispose()

        const layer = cropping ? this.map.croppingLayer : this.map.fieldsLayer
        layer.selectable = true
        this.map.setSelectableLayers([layer])

        this.featureSelectionFilter = feature => {
            const field = feature.get("data")
            if (fields.isFieldViewModel(field)) {
                return filter(field)
            }
        }

        this.watcher = this.map.watchSelection(features => {
            const fields = features.map(f => f.get("data")).filter(omnia.fields.isFieldViewModel)
            watcher(fields)
        })

    }

    setSelection(fields: FieldViewModel[]) {
        this.map.selectFeatures(this.map.findFeaturesWithData(fields))
    }

}
